module.exports = __webpack_public_path__ + "static/media/sopt11kz.df32656f.pdf";